import OrderItemName from './OrderItemName'

export default OrderItemName
